import React, { useState, useRef } from "react";

const C = {
  bg:     "#C4622D",
  forest: "#2D5A3D",
  dark:   "#1C3A28",
  text:   "#1C1C1E",
  muted:  "#8A8A8E",
  border: "#D3D1C7",
};

/* ── Items Voyage, Hivernal, Sécurité ────────────────────────── */

const getVoyageItems = (t) => [
  { id: "dep_fenetre",    label: t.dep_fenetre    || "Fenêtres fermées",      desc: t.dep_fenetre_desc    || "Verrouillées et étanches" },
  { id: "dep_store",      label: t.dep_store      || "Store rentré",          desc: t.dep_store_desc      || "Auvent replié" },
  { id: "dep_frigo",      label: t.dep_frigo      || "Frigo en 12V",          desc: t.dep_frigo_desc      || "Basculer sur batterie" },
  { id: "dep_antenne",    label: t.dep_antenne    || "Antenne TV",            desc: t.dep_antenne_desc    || "Repliée et fixée" },
  { id: "dep_robinets",   label: t.dep_robinets   || "Robinets fermés",       desc: t.dep_robinets_desc   || "Circuit eau coupé" },
  { id: "dep_gaz",        label: t.dep_gaz        || "Gaz coupé",             desc: t.dep_gaz_desc        || "Robinet principal fermé" },
  { id: "dep_joints",     label: t.dep_joints     || "Joints de fenêtres",    desc: t.dep_joints_desc     || "Pas de fissures ni décollement" },
  { id: "dep_toit",       label: t.dep_toit       || "Toit et lanterneaux",   desc: t.dep_toit_desc       || "Étanches, pas de fissure" },
  { id: "dep_trappe",     label: t.dep_trappe     || "Trappe eau propre",     desc: t.dep_trappe_desc     || "Pas de fuite autour" },
  { id: "dep_marchepied", label: t.dep_marchepied || "Marchepied rentré",     desc: t.dep_marchepied_desc || "Fixé pour la route" },
  { id: "dep_cable220",   label: t.dep_cable220   || "Câble 220V",            desc: t.dep_cable220_desc   || "Déconnecté et rangé" },
  { id: "dep_placards",   label: t.dep_placards   || "Placards fermés",       desc: t.dep_placards_desc   || "Tous verrouillés" },
];

const getHivernalItems = (t) => [
  { id: "hiv_batterie",    label: t.hiv_batterie    || "Batterie débranchée",  desc: t.hiv_batterie_desc    || "Borne négative déconnectée" },
  { id: "hiv_eau",         label: t.hiv_eau         || "Circuits eau vidangés", desc: t.hiv_eau_desc         || "Pompe, chauffe-eau, durites" },
  { id: "hiv_antigel",     label: t.hiv_antigel     || "Antigel ajouté",       desc: t.hiv_antigel_desc     || "Siphons et WC" },
  { id: "hiv_gaz",         label: t.hiv_gaz         || "Gaz fermé",            desc: t.hiv_gaz_desc         || "Bouteilles déconnectées" },
  { id: "hiv_frigo",       label: t.hiv_frigo       || "Frigo ouvert",         desc: t.hiv_frigo_desc       || "Porte calée ouverte" },
  { id: "hiv_ventilation", label: t.hiv_ventilation || "Ventilation ouverte",  desc: t.hiv_ventilation_desc || "Éviter la condensation" },
  { id: "hiv_pneus",       label: t.hiv_pneus       || "Pression pneus",       desc: t.hiv_pneus_desc       || "Gonfler à +0,2 bar" },
  { id: "hiv_bache",       label: t.hiv_bache       || "Bâche installée",      desc: t.hiv_bache_desc       || "Protégée des UV et humidité" },
];

const getSecuriteItems = (t) => [
  { id: "sec_gilet",      label: t.sec_gilet      || "Gilets jaunes",        desc: t.sec_gilet_desc      || "Accessibles sans ouvrir le coffre" },
  { id: "sec_triangle",   label: t.sec_triangle   || "Triangle de sécurité", desc: t.sec_triangle_desc   || "Conforme et accessible" },
  { id: "sec_extincteur", label: t.sec_extincteur || "Extincteur",           desc: t.sec_extincteur_desc || "Chargé et accessible" },
  { id: "sec_trousse",    label: t.sec_trousse    || "Trousse de secours",   desc: t.sec_trousse_desc    || "Complète et à jour" },
  { id: "sec_detecteur",  label: t.sec_detecteur  || "Détecteur CO/Gaz",    desc: t.sec_detecteur_desc  || "Testé et fonctionnel" },
  { id: "sec_assurance",  label: t.sec_assurance  || "Assurance à jour",     desc: t.sec_assurance_desc  || "Carte verte dans le véhicule" },
  { id: "sec_permis",     label: t.sec_permis     || "Permis & papiers",     desc: t.sec_permis_desc     || "Présents dans le véhicule" },
];

const SUBTABS = [
  { id: "voyage",      label: "Voyage" },
  { id: "hivernal",    label: "Hivernal" },
  { id: "securite",    label: "Sécurité" },
  { id: "perso",       label: "Personnalisé" },
];

/* ── Composants communs ──────────────────────────────────────── */

function Checkbox({ checked }) {
  return (
    <div style={{
      width: 22, height: 22, borderRadius: 6, flexShrink: 0,
      background: checked ? C.forest : "white",
      border: `2px solid ${checked ? C.forest : C.border}`,
      display: "flex", alignItems: "center", justifyContent: "center",
      transition: "all 0.15s",
    }}>
      {checked && (
        <svg width="12" height="9" viewBox="0 0 12 9" fill="none">
          <path d="M1 4.5L4 7.5L11 1" stroke="white" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </div>
  );
}

function CheckItem({ id, label, desc, checks, onCheck }) {
  const checked = checks[id] === true;
  return (
    <div
      onClick={() => onCheck(id, checked ? null : true)}
      style={{
        display: "flex", alignItems: "center", gap: 12,
        padding: "12px 14px", cursor: "pointer",
        background: checked ? "#F5FBF6" : "white",
        transition: "background 0.15s",
      }}
    >
      <Checkbox checked={checked} />
      <div style={{ flex: 1 }}>
        <span style={{
          fontSize: 13, fontWeight: 700,
          color: checked ? C.muted : C.text,
          textDecoration: checked ? "line-through" : "none",
          transition: "all 0.15s",
        }}>
          {label}
        </span>
        {desc && (
          <span style={{ fontSize: 11, color: C.muted, marginLeft: 6 }}>{desc}</span>
        )}
      </div>
    </div>
  );
}

function ProgressBar({ items, checks, t = {} }) {
  const nDone = items.filter(i => checks[i.id] === true).length;
  const total = items.length;
  const pct = total ? Math.round((nDone / total) * 100) : 0;
  const allDone = nDone === total;

  return (
    <div style={{ background: C.dark, borderRadius: 12, padding: "12px 16px", marginBottom: 10 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: "rgba(248,246,241,0.7)" }}>{t.progression || "Progression"}</span>
        <span style={{ fontSize: 12, fontWeight: 800, color: "#9FE1CB" }}>{nDone}/{total}</span>
      </div>
      <div style={{ height: 6, background: "rgba(255,255,255,0.12)", borderRadius: 99, overflow: "hidden" }}>
        <div style={{
          height: "100%", width: `${pct}%`,
          background: allDone ? "#2D9E4A" : "#9FE1CB",
          borderRadius: 99, transition: "width 0.4s ease",
        }} />
      </div>
      {allDone && (
        <div style={{ marginTop: 10, fontSize: 13, fontWeight: 800, color: "#9FE1CB", textAlign: "center" }}>
          {t.toutVerifie || "✓ Tout est vérifié — Bon voyage !"}
        </div>
      )}
    </div>
  );
}

/* ── Sous-écrans ─────────────────────────────────────────────── */

function FlatChecklist({ items, checks, onCheck, t = {} }) {
  return (
    <div style={{ background: C.bg, minHeight: "100%", paddingBottom: 24 }}>
      <div style={{ padding: "14px 14px 0" }}>
        <ProgressBar items={items} checks={checks} t={t} />
        <div style={{
          background: "white", borderRadius: 12, overflow: "hidden",
          border: `2px solid ${C.dark}`,
        }}>
          {items.map((item, idx) => (
            <div key={item.id} style={{
              borderBottom: idx < items.length - 1 ? "1px solid #EDEDEA" : "none",
            }}>
              <CheckItem id={item.id} label={item.label} desc={item.desc} checks={checks} onCheck={onCheck} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


function PersoTab({ items, setItems, checks, onCheck, t = {} }) {
  const [inputVal, setInputVal] = useState("");
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const inputRef = useRef(null);

  const addItem = () => {
    const label = inputVal.trim();
    if (!label) return;
    setItems(prev => [...prev, { id: "perso_" + Date.now(), label }]);
    setInputVal("");
    inputRef.current?.focus();
  };

  const deleteItem = (id) => {
    setItems(prev => prev.filter(i => i.id !== id));
    onCheck(id, null);
  };

  const nOk    = items.filter(i => checks[i.id] === "ok").length;
  const total  = items.length;
  const pct    = total ? Math.round((nOk / total) * 100) : 0;
  const allDone = total > 0 && nOk === total;

  const STATE_COLORS = {
    ok:   { border: "#22C55E", bg: "#F0FDF4", row: "#F5FBF6" },
    warn: { border: "#F59E0B", bg: "#FFFBEB", row: "#FFFBEB" },
    nok:  { border: "#EF4444", bg: "#FEF2F2", row: "#FEF2F2" },
  };

  return (
    <div style={{ background: C.bg, minHeight: "100%", paddingBottom: 24 }}>
      <div style={{ padding: "14px 14px 0" }}>

        {/* Barre de progression */}
        {total > 0 && (
          <div style={{ background: C.dark, borderRadius: 12, padding: "12px 16px", marginBottom: 10 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: "rgba(248,246,241,0.7)" }}>{t.progression || "Progression"}</span>
              <span style={{ fontSize: 12, fontWeight: 800, color: "#9FE1CB" }}>{nOk}/{total}</span>
            </div>
            <div style={{ height: 6, background: "rgba(255,255,255,0.12)", borderRadius: 99, overflow: "hidden" }}>
              <div style={{
                height: "100%", width: `${pct}%`,
                background: allDone ? "#2D9E4A" : "#9FE1CB",
                borderRadius: 99, transition: "width 0.4s ease",
              }} />
            </div>
            {allDone && (
              <div style={{ marginTop: 10, fontSize: 13, fontWeight: 800, color: "#9FE1CB", textAlign: "center" }}>
                {t.toutVerifie || "✓ Tout est vérifié — Bon voyage !"}
              </div>
            )}
          </div>
        )}

        {/* Champ d'ajout */}
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          <input
            ref={inputRef}
            type="text"
            value={inputVal}
            onChange={e => setInputVal(e.target.value)}
            onKeyDown={e => e.key === "Enter" && addItem()}
            placeholder={t.nouvelElement || "Nouvel élément à vérifier…"}
            style={{
              flex: 1, padding: "12px 14px",
              borderRadius: 10, border: `1.5px solid ${C.border}`,
              background: "white", color: C.text,
              fontSize: 14, outline: "none",
              fontFamily: "inherit", boxSizing: "border-box",
            }}
          />
          <button
            onClick={addItem}
            style={{
              padding: "12px 16px", borderRadius: 10, border: "none",
              background: C.forest, color: "white",
              fontSize: 14, fontWeight: 800,
              cursor: "pointer", fontFamily: "inherit", flexShrink: 0,
            }}
          >
            {t.ajouterBtn || "Ajouter"}
          </button>
        </div>

        {/* Liste vide */}
        {total === 0 && (
          <div style={{
            background: C.dark, borderRadius: 12, padding: "32px 20px",
            textAlign: "center", color: "rgba(248,246,241,0.5)", fontSize: 13, lineHeight: 1.6,
          }}>
            {t.ajoutezPropres || "Ajoutez vos propres éléments à vérifier avant le départ"}
          </div>
        )}

        {/* Liste des items */}
        {total > 0 && (
          <div style={{ background: "white", borderRadius: 12, overflow: "hidden", border: `2px solid ${C.dark}` }}>
            {items.map((item, idx) => {
              const state = checks[item.id];
              const sc = STATE_COLORS[state] || {};
              return (
                <div
                  key={item.id}
                  style={{
                    display: "flex", alignItems: "center", gap: 10,
                    padding: "11px 12px",
                    background: sc.row || "white",
                    borderBottom: idx < items.length - 1 ? "1px solid #EDEDEA" : "none",
                    transition: "background 0.15s",
                  }}
                >
                  {/* Label */}
                  <span style={{
                    flex: 1, fontSize: 13, fontWeight: 700,
                    color: state === "ok" ? C.muted : C.text,
                    textDecoration: state === "ok" ? "line-through" : "none",
                    transition: "all 0.15s",
                  }}>
                    {item.label}
                  </span>

                  {/* ✅ ⚠️ ❌ */}
                  {[
                    { val: "ok",   emoji: "✅" },
                    { val: "warn", emoji: "⚠️" },
                    { val: "nok",  emoji: "❌" },
                  ].map(btn => {
                    const active = state === btn.val;
                    const col = STATE_COLORS[btn.val];
                    return (
                      <button
                        key={btn.val}
                        onClick={() => onCheck(item.id, active ? null : btn.val)}
                        style={{
                          width: 34, height: 34, borderRadius: 8, padding: 0,
                          border: active ? `2px solid ${col.border}` : "1.5px solid #EDEDEA",
                          background: active ? col.bg : "white",
                          cursor: "pointer", fontSize: 15,
                          display: "flex", alignItems: "center", justifyContent: "center",
                          opacity: state && !active ? 0.35 : 1,
                          transition: "all 0.15s", flexShrink: 0,
                        }}
                      >
                        {btn.emoji}
                      </button>
                    );
                  })}

                  {/* Suppression avec confirmation */}
                  {confirmDeleteId === item.id ? (
                    <div style={{ display: "flex", gap: 6 }}>
                      <button onClick={() => setConfirmDeleteId(null)} style={{ background: "none", border: "1px solid #D3D1C7", borderRadius: 8, padding: "4px 8px", color: "#8A8A8E", cursor: "pointer", fontSize: 11 }}>{t.annuler || "Annuler"}</button>
                      <button onClick={() => { setItems(prev => prev.filter(x => x.id !== item.id)); setConfirmDeleteId(null); }} style={{ background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 8, padding: "4px 8px", color: "#DC2626", cursor: "pointer", fontSize: 11, fontWeight: 700 }}>{t.supprimer || "🗑️ Supprimer"}</button>
                    </div>
                  ) : (
                    <button onClick={() => setConfirmDeleteId(item.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "#D3D1C7", fontSize: 16 }}>✕</button>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

/* ── Écran principal ─────────────────────────────────────────── */
export default function DepartScreen({ checks, onCheck, persoItems, setPersoItems, subTabBar, t = {} }) {
  const [subTab, setSubTab] = useState("voyage");
  const voyageItems   = getVoyageItems(t);
  const hivernalItems = getHivernalItems(t);
  const securiteItems = getSecuriteItems(t);

  return (
    <div style={{ background: C.bg, minHeight: "calc(100vh - 168px)" }}>

      <div style={{ background: C.forest }}>
        {subTabBar && subTabBar}
        {/* Barre de sous-onglets */}
        <div style={{
          display: "flex", padding: "10px 10px 0",
          gap: 4,
        }}>
        {SUBTABS.map(st => {
          const on = subTab === st.id;
          const label = { voyage: t.tabVoyage, hivernal: t.tabHivernal, securite: t.tabSecurite, perso: t.tabPerso }[st.id] || st.label;
          return (
            <button
              key={st.id}
              onClick={() => setSubTab(st.id)}
              style={{
                flex: 1, padding: "9px 4px 10px",
                borderRadius: "10px 10px 0 0",
                border: "none",
                borderBottom: "none",
                background: on ? "#2D5A3D" : "#C4622D",
                color: "white",
                fontWeight: on ? 800 : 600,
                fontSize: 10, cursor: "pointer",
                fontFamily: "inherit",
                transition: "color 0.2s, border-color 0.2s",
                letterSpacing: 0.2,
              }}
            >
              {label}
            </button>
          );
        })}
        </div>
      </div>

      {subTab === "voyage"   && <FlatChecklist items={voyageItems}   checks={checks} onCheck={onCheck} t={t} />}
      {subTab === "hivernal" && <FlatChecklist items={hivernalItems} checks={checks} onCheck={onCheck} t={t} />}
      {subTab === "securite" && <FlatChecklist items={securiteItems} checks={checks} onCheck={onCheck} t={t} />}
      {subTab === "perso"    && <PersoTab items={persoItems || []} setItems={setPersoItems} checks={checks} onCheck={onCheck} t={t} />}
    </div>
  );
}
